<div class="base-container">
  <nav class="navbar">
    <div class="container">
      <div class="flex flex-space-between">
        <div class="flex">
          <h1 class="is-size-3 has-text-weight-semibold">Data Aggregering Admin</h1>
        </div>
      </div>
    </div>
  </nav>

  <div class="container" style="background: #fff">
    <div class="main-layout text-center">
      <section class="main-content">
        <span class="errorstatus">{{ status }}</span>
        <span class="errormessage">{{ error }}</span>
      </section>
    </div>
  </div>
</div>
